
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1640"}},[_c('g',{attrs:{"data-name":"Group 1639"}},[_c('g',{attrs:{"data-name":"Group 1638"}},[_c('rect',{attrs:{"data-name":"Rectangle 2369","width":"16","height":"20","rx":"1","transform":"translate(2)","fill":"#adadad"}})]),_c('path',{attrs:{"data-name":"Path 1003","d":"M6 11a1 1 0 01-1-1V8a3 3 0 013-3h3.586l-.293-.293a1 1 0 111.414-1.415l2 2A1 1 0 0114 7H8a1 1 0 00-1 1v2a1 1 0 01-1 1z"}}),_c('path',{attrs:{"data-name":"Path 1004","d":"M8 17a1 1 0 01-.707-.293l-2-2A1 1 0 016 13h6a1 1 0 001-1v-2a1 1 0 112 0v2a3 3 0 01-3 3H8.414l.293.292A1 1 0 018 17z"}})]),_c('path',{attrs:{"data-name":"Rectangle 2370","fill":"none","d":"M0 0h20v20H0z"}})])])
          )
        }
      }
    